import React, { Component } from 'react';
import EResourceItem from './EResourceItem';
import { Card } from 'react/card/Card';
import CardTitle from 'react/card/CardTitle';
import { OverviewFooter } from "../../card/OverviewFooter";

import '../../card/cardContent.less';
import "./eResourceItem.less";
import "./eResourcesView.less";

class EResourcesView extends Component {
    renderEResources() {
        return this.props.cardModel.map((eResource, index) => {
            return (
				<EResourceItem key={index}
					imageUrl={eResource.imageUrl}
					displayText={eResource.displayName}
                    destId={eResource.url}
                    srcId={eResource.srcId}
					url={eResource.url}>
				</EResourceItem>
            );
        });
    }

    render() {
        return (
            <Card>
                <CardTitle title="E-Resources" />
                <div className="eresources-container">
                    {this.renderEResources()}
                </div>
                <OverviewFooter />
            </Card>
        );
    }
}

export default EResourcesView;



// WEBPACK FOOTER //
// ./src/react/views/eResources/EResourcesView.jsx